(function () {
  'use strict';

  /* ── CONFIG ──────────────────────────────────────────────── */
  var TARGET_VARIANT_ID = 53073628168491;
  var TOTAL_QUESTIONS   = 6;
  var MAX_SCORE         = 18;

  /* ── VSL CONFIG ──────────────────────────────────────────── */
  var VSL_VIDEO_ID      = '13QK7JUdUA0';
  var VSL_REQUIRED_SEC  = 120; // 2 minutos obrigatórios

  /* ── ESTADO ──────────────────────────────────────────────── */
  var totalScore  = 0;
  var currentStep = 0;

  /* ── VSL STATE ───────────────────────────────────────────── */
  var vslPlayer            = null;
  var vslApiLoaded         = false;
  var vslWatchedSeconds    = 0;
  var vslWatchInterval     = null;
  var vslSoundActivated    = false;
  var vslMilestones        = { started:false, m25:false, m50:false, m75:false, unlocked:false };

  /* ── BANDAS DE PONTUAÇÃO ──────────────────────────────────── */
  var BANDS = [
    {
      min: 0, max: 5, label: 'MODERADO',
      cssClass: 'qz-score-badge--moderate',
      message: 'Seu sistema nervoso mostra alguns sinais de tensão acumulada. Agir agora — antes que o padrão se aprofunde — é a decisão mais inteligente que você pode tomar. O seu corpo já está te dando os avisos.'
    },
    {
      min: 6, max: 11, label: 'ELEVADO',
      cssClass: 'qz-score-badge--elevated',
      message: 'Seu sistema nervoso está operando em estado de alerta prolongado. O que você sente não é fraqueza — é o sinal claro de que o seu corpo acumulou mais do que consegue processar sozinho. É hora de oferecer a ele o suporte que precisa.'
    },
    {
      min: 12, max: 18, label: 'CRÍTICO',
      cssClass: 'qz-score-badge--critical',
      message: 'Seu sistema nervoso está no limite. Cada dia sem cuidado aprofunda o padrão — e o corpo cobra essa dívida com juros. O que você está sentindo não é normalidade: é o resultado de anos sem o suporte certo. Você merece muito mais do que isso.'
    }
  ];

  /* ── HELPERS ─────────────────────────────────────────────── */
  function getBand(score) {
    for (var i = 0; i < BANDS.length; i++) {
      if (score >= BANDS[i].min && score <= BANDS[i].max) return BANDS[i];
    }
    return BANDS[BANDS.length - 1];
  }

  function scoreToPercent(score) {
    var raw = Math.round((score / MAX_SCORE) * 100);
    return Math.max(raw, 18);
  }

  function firePixel(eventName, extra) {
    if (typeof fbq !== 'function') return;
    var payload = { content_name: 'VSL Ressonancia Curativa', content_category: 'Middle of Funnel' };
    if (extra) { for (var k in extra) payload[k] = extra[k]; }
    try { fbq('trackCustom', eventName, payload); } catch (e) { /* silent */ }
  }

  /* ── NAVEGAÇÃO ───────────────────────────────────────────── */
  function goToStep(stepNumber) {
    document.querySelectorAll('.qz-step').forEach(function (el) {
      el.classList.remove('is-active');
      el.style.display = 'none';
    });

    /* Usa seletor baseado em string para suportar "7.5" */
    var next = document.querySelector('.qz-step[data-step="' + stepNumber + '"]');
    if (!next) return;

    currentStep = stepNumber;
    next.style.display = 'block';
    setTimeout(function () { next.classList.add('is-active'); }, 10);
    window.scrollTo({ top: 0, behavior: 'smooth' });

    var numericStep = parseFloat(stepNumber);
    if (numericStep >= 1 && numericStep <= TOTAL_QUESTIONS) {
      updateProgress(numericStep);
    }

    if (stepNumber === '7' || numericStep === 7) {
      displayScore();
    }

    if (stepNumber === '7.5' || numericStep === 7.5) {
      initVSL();
    }
  }

  /* ── BARRA DE PROGRESSO ──────────────────────────────────── */
  function updateProgress(step) {
    var fill = document.getElementById('qz-progress-fill');
    if (!fill) return;
    var pct = Math.round((Math.min(step, TOTAL_QUESTIONS) / TOTAL_QUESTIONS) * 100);
    fill.style.width = pct + '%';
  }

  /* ── EXIBIÇÃO DO SCORE (STEP 7) ──────────────────────────── */
  function displayScore() {
    var band       = getBand(totalScore);
    var pct        = scoreToPercent(totalScore);
    var badgeEl    = document.getElementById('qz-score-badge');
    var numberEl   = document.getElementById('qz-score-number');
    var bandEl     = document.getElementById('qz-score-band');
    var messageEl  = document.getElementById('qz-score-message');

    if (numberEl)  numberEl.textContent  = pct;
    if (bandEl)    bandEl.textContent    = band.label;
    if (messageEl) messageEl.textContent = band.message;

    if (badgeEl) {
      badgeEl.classList.remove('qz-score-badge--moderate','qz-score-badge--elevated','qz-score-badge--critical');
      badgeEl.classList.add(band.cssClass);
    }

    var fill = document.getElementById('qz-progress-fill');
    if (fill) fill.style.width = '100%';
  }

  /* ══════════════════════════════════════════════════════════
     VSL — YouTube Player + Trava de 2 Minutos + Pixel Tracking
     ══════════════════════════════════════════════════════════ */

  function initVSL() {
    if (vslApiLoaded) {
      /* Se já carregou antes e usuário voltou, reinstanciar o player */
      if (!vslPlayer && window.YT && window.YT.Player) {
        createVSLPlayer();
      }
      return;
    }
    vslApiLoaded = true;

    /* Carrega a YouTube IFrame API apenas quando o usuário chega ao step 7.5 */
    window.onYouTubeIframeAPIReady = function () {
      createVSLPlayer();
    };

    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createVSLPlayer() {
    var container = document.getElementById('qz-vsl-player');
    if (!container) return;

    vslPlayer = new YT.Player('qz-vsl-player', {
      videoId: VSL_VIDEO_ID,
      host: 'https://www.youtube-nocookie.com',
      playerVars: {
        autoplay: 1,
        mute: 1,
        controls: 0,
        disablekb: 1,
        modestbranding: 1,
        rel: 0,
        playsinline: 1,
        iv_load_policy: 3,
        fs: 0,
        showinfo: 0,
        cc_load_policy: 0
      },
      events: {
        'onReady': onVSLPlayerReady,
        'onStateChange': onVSLPlayerStateChange,
        'onError': onVSLPlayerError
      }
    });

    setupSoundOverlay();
  }

  function onVSLPlayerReady(event) {
    var loader = document.getElementById('qz-vsl-loader');
    if (loader) loader.style.display = 'none';

    try { event.target.playVideo(); } catch (e) {}
  }

  function onVSLPlayerStateChange(event) {
    /* YT.PlayerState: UNSTARTED=-1, ENDED=0, PLAYING=1, PAUSED=2, BUFFERING=3, CUED=5 */
    if (event.data === 1) {
      if (!vslMilestones.started && vslSoundActivated) {
        vslMilestones.started = true;
        firePixel('VSL_Started');
      }
      startWatchTimer();
    } else {
      stopWatchTimer();
    }

    if (event.data === 0) {
      /* Vídeo terminou — garante liberação mesmo que o timer tenha dessincronizado */
      if (!vslMilestones.unlocked) unlockVSLCTA();
    }
  }

  function onVSLPlayerError() {
    /* Fallback: libera após VSL_REQUIRED_SEC reais mesmo sem player */
    var counter = document.getElementById('qz-vsl-counter');
    if (counter) counter.textContent = 'Problema ao carregar o vídeo. Liberando acesso…';
    setTimeout(unlockVSLCTA, VSL_REQUIRED_SEC * 1000);
  }

  function setupSoundOverlay() {
    var overlay = document.getElementById('qz-vsl-sound-overlay');
    if (!overlay) return;

    overlay.addEventListener('click', function () {
      if (vslPlayer && typeof vslPlayer.unMute === 'function') {
        try {
          vslPlayer.unMute();
          vslPlayer.setVolume(100);
          vslPlayer.seekTo(0, true);
          vslPlayer.playVideo();
        } catch (e) {}
      }

      overlay.style.opacity = '0';
      setTimeout(function () { overlay.style.display = 'none'; }, 300);

      vslSoundActivated = true;
      vslWatchedSeconds = 0;

      /* Dispara pixel de início real (com som) */
      if (!vslMilestones.started) {
        vslMilestones.started = true;
        firePixel('VSL_Started');
      }

      updateVSLProgress();
      startWatchTimer();
    });
  }

  function startWatchTimer() {
    if (vslWatchInterval) return;
    if (!vslSoundActivated) return; /* Só conta após ativar o som */

    vslWatchInterval = setInterval(function () {
      vslWatchedSeconds += 1;
      updateVSLProgress();
      checkVSLMilestones();

      if (vslWatchedSeconds >= VSL_REQUIRED_SEC && !vslMilestones.unlocked) {
        unlockVSLCTA();
      }
    }, 1000);
  }

  function stopWatchTimer() {
    if (vslWatchInterval) {
      clearInterval(vslWatchInterval);
      vslWatchInterval = null;
    }
  }

  function updateVSLProgress() {
    var pct = Math.min(100, Math.round((vslWatchedSeconds / VSL_REQUIRED_SEC) * 100));

    var fill = document.getElementById('qz-vsl-progress-fill');
    if (fill) fill.style.width = pct + '%';

    var pctLabel = document.getElementById('qz-vsl-progress-pct');
    if (pctLabel) pctLabel.textContent = pct + '%';

    var counter = document.getElementById('qz-vsl-counter');
    if (counter) {
      if (vslWatchedSeconds >= VSL_REQUIRED_SEC) {
        counter.textContent = '✓ Acesso desbloqueado';
      } else {
        var remaining = Math.max(0, VSL_REQUIRED_SEC - vslWatchedSeconds);
        var mm = Math.floor(remaining / 60);
        var ss = remaining % 60;
        counter.textContent = 'Faltam ' + mm + ':' + (ss < 10 ? '0' + ss : ss) + ' para desbloquear';
      }
    }
  }

  function checkVSLMilestones() {
    if (!vslMilestones.m25 && vslWatchedSeconds >= 30) {
      vslMilestones.m25 = true;
      firePixel('VSL_25Percent');
    }
    if (!vslMilestones.m50 && vslWatchedSeconds >= 60) {
      vslMilestones.m50 = true;
      firePixel('VSL_50Percent');
    }
    if (!vslMilestones.m75 && vslWatchedSeconds >= 90) {
      vslMilestones.m75 = true;
      firePixel('VSL_75Percent');
    }
  }

  function unlockVSLCTA() {
    if (vslMilestones.unlocked) return;
    vslMilestones.unlocked = true;
    stopWatchTimer();

    firePixel('VSL_Unlocked');

    var cta  = document.getElementById('qz-vsl-cta');
    var lock = document.getElementById('qz-vsl-lock-msg');

    if (cta) {
      cta.style.display = 'block';
      setTimeout(function () { cta.classList.add('is-visible'); }, 30);
    }
    if (lock) {
      lock.textContent = '✓ Seu acesso foi liberado. Clique abaixo para continuar.';
      lock.classList.add('is-unlocked');
    }

    updateVSLProgress();
  }

  /* ── LOADING INTERMEDIÁRIO (após última resposta) ─────────── */
  function handleFinalAnswer() {
    document.querySelectorAll('.qz-step').forEach(function (el) {
      el.style.display = 'none';
      el.classList.remove('is-active');
    });

    var loading = document.getElementById('qz-loading');
    var titleEl = document.getElementById('qz-loading-title');
    var subEl   = document.getElementById('qz-loading-sub');

    if (titleEl) titleEl.textContent = 'Analisando seu perfil…';
    if (subEl)   subEl.textContent   = 'Calculando seu índice de estresse com base nas suas respostas.';
    if (loading) loading.style.display = 'block';

    updateProgress(6);

    if (typeof fbq === 'function') {
      fbq('track', 'Lead', {
        content_name: 'Quiz Nivel de Estresse',
        content_category: 'Top of Funnel'
      });
    }

    setTimeout(function () {
      if (loading) loading.style.display = 'none';
      goToStep(7);
    }, 2200);
  }

  /* ── CHECKOUT FINAL ──────────────────────────────────────── */
  function triggerCheckout() {
    document.querySelectorAll('.qz-step').forEach(function (el) {
      el.style.display = 'none';
      el.classList.remove('is-active');
    });

    var loading = document.getElementById('qz-loading');
    var titleEl = document.getElementById('qz-loading-title');
    var subEl   = document.getElementById('qz-loading-sub');

    if (titleEl) titleEl.textContent = 'Adicionando ao Carrinho…';
    if (subEl)   subEl.textContent   = 'Você será redirecionada em instantes.';
    if (loading) loading.style.display = 'block';

    if (typeof fbq === 'function') {
      fbq('track', 'InitiateCheckout', {
        content_ids: [TARGET_VARIANT_ID],
        content_type: 'product',
        value: 298.10,
        currency: 'BRL'
      });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: TARGET_VARIANT_ID, quantity: 1 }] })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('cart error ' + res.status);
      window.location.href = '/checkout';
    })
    .catch(function (err) {
      console.error('[RC Quiz] Checkout error:', err);
      window.location.href = '/products/kit-completo-ressonancia-curativa';
    });
  }

  /* ── DELEGAÇÃO DE EVENTOS ────────────────────────────────── */
  document.addEventListener('click', function (e) {
    /* Botão de checkout */
    var btnCheckout = e.target.closest('[data-checkout]');
    if (btnCheckout) {
      triggerCheckout();
      return;
    }

    /* CTA da VSL: dispara pixel extra antes de avançar */
    var btnVslCta = e.target.closest('#qz-vsl-cta');
    if (btnVslCta) {
      firePixel('VSL_CTAClick');
      goToStep('8');
      return;
    }

    /* Botão de avançar step (data-next) */
    var btnNext = e.target.closest('.qz-btn[data-next]');
    if (btnNext) {
      goToStep(btnNext.dataset.next);
      return;
    }

    /* Opção de resposta */
    var optBtn = e.target.closest('.qz-option');
    if (!optBtn) return;
    if (optBtn.classList.contains('is-selected')) return;

    var score = parseInt(optBtn.getAttribute('data-score') || '0', 10);
    totalScore += score;

    optBtn.classList.add('is-selected');
    var siblings = optBtn.closest('.qz-options');
    if (siblings) {
      siblings.querySelectorAll('.qz-option').forEach(function (b) {
        b.style.pointerEvents = 'none';
      });
    }

    if (optBtn.hasAttribute('data-final')) {
      setTimeout(function () { handleFinalAnswer(); }, 380);
    } else {
      var nextStep = optBtn.getAttribute('data-next') || '0';
      setTimeout(function () { goToStep(nextStep); }, 260);
    }
  });

  /* ── INICIALIZAÇÃO ───────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.qz-step').forEach(function (el) {
      el.style.display = 'none';
      el.classList.remove('is-active');
    });

    var firstStep = document.querySelector('.qz-step[data-step="0"]');
    if (firstStep) {
      firstStep.style.display = 'block';
      setTimeout(function () { firstStep.classList.add('is-active'); }, 10);
    }

    updateProgress(0);
  });

})();